<template>
  <div class="form-wrapper">
    <h2>Placements</h2>

    <div class="info-box">
      <strong>Automatic Placement</strong>
      <p>
        Placements are handled automatically across all platforms — Meta,
        TikTok, and Snapchat. Just set up your campaign, and we’ll take care of
        delivering it to the best-performing placements.
      </p>
    </div>

    <div class="form-group">
      <label class="group-label">
        Brand safety and suitability <span class="required">*</span>
      </label>
      <div class="options-wrapper">
        <div
          class="option-card"
          v-for="option in brandSafetyOptions"
          :key="option.value"
          :class="{ selected: brandSafety === option.value }"
          @click="brandSafety = option.value"
        >
          <div
            class="circle"
            :class="{ active: brandSafety === option.value }"
          ></div>
          <strong class="mt-6">{{ option.title }}</strong>
          <p>{{ option.description }}</p>
        </div>
      </div>
    </div>

    <div class="form-group flex2" v-if="Store.activeBid">
      <label for="delivery-type">
        Delivery type <span class="required">*</span>
      </label>
      <v-select
        v-model="deliveryType"
        :items="deliveryoptions"
        variant="outlined"
        placeholder="Select delivery type"
        density="compact"
        hide-details
        style="width: 100%"
      />
    </div>
  </div>
</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";
export default {
  name: "PlacementSettings",
  computed: {
    Store() {
      return useSuperAddStore();
    },
    brandSafety: {
      get() {
        return this.Store.brandSafety;
      },
      set(val) {
        this.Store.brandSafety = val;
      },
    },
    deliveryType: {
      get() {
        return this.Store.deliveryType;
      },
      set(val) {
        this.Store.deliveryType = val;
      },
    },
  },
  data() {
    return {
      deliveryoptions: ["Standard", "Accelerated"],
      brandSafetyOptions: [
        {
          value: "expanded",
          title: "Expanded Inventory",
          description:
            "Your ads may show alongside a wider range of content, helping you reach more people while still maintaining a balanced level of brand suitability across Meta, TikTok, and Snapchat.",
        },
        {
          value: "moderate",
          title: "Moderate Inventory",
          description:
            "Your ads appear in environments that strike a balance between reach and brand safety. This option avoids high-risk content while still giving your campaigns strong visibility across Meta, TikTok, and Snapchat.",
        },
        {
          value: "limited",
          title: "Limited Inventory",
          description:
            "Ensures the highest level of brand safety by placing your ads only next to content that meets strict suitability standards. It’s ideal for brands that prioritize a controlled and risk-free advertising environment across all platforms.",
        },
      ],
    };
  },
  methods: {
    validate() {
      const errors = [];

      if (!this.brandSafety) {
        errors.push("Brand safety selection is required.");
      }

      if (this.Store.activeBid && !this.deliveryType) {
        errors.push("Delivery type is required.");
      }

      return errors.length ? errors : null;
    },
    getData() {
      return {
        brandSafety: this.brandSafety,
        deliveryType: this.Store.activeBid ? this.deliveryType : null,
      };
    },
  },
};
</script>

<style scoped>
.form-wrapper {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: auto;
}

h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.info-box {
  background: #fafafa;
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #eee;
  box-shadow: 0px 2px 8px rgba(102, 102, 102, 0.2);
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}
.flex2 {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  gap: 1rem;
}
.flex2 label {
  min-width: 14rem;
}

.group-label {
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: block;
}

.options-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.option-card {
  flex: 1 1 260px;
  border: 1px solid #e5e5e5;
  padding: 1rem;
  border-radius: 10px;
  cursor: pointer;
  background: #fff;
  transition: all 0.3s ease;
  position: relative;
}

.option-card:hover {
  background: #f5f5f5;
}

.option-card.selected {
  border: 2px solid #207878;
}

.option-card strong {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 16px;
}

.option-card p {
  font-size: 14px;
  color: #555;
}

.circle {
  width: 16px;
  height: 16px;
  border: 2px solid #aaa;
  border-radius: 50%;
  position: absolute;
  top: 1rem;
  left: 1rem;
}

.circle.active {
  border-color: #207878;
  background: #207878;
}

select {
  padding: 0.65rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 100%;
  max-width: 300px;
}

.required {
  color: red;
}
</style>
